import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home.vue'
import login from '@/components/login.vue'
// import index from '@/components/index/index.vue'
import index from '@/components/index/StIndex.vue'
import notFound from '@/components/404.vue'
// ==== 安全管理 END ====
import Locales from '@/components/language/app.js'
let s = localStorage.getItem("system_lang") || 'zh_cn'

Vue.use(Router)
// 不需要根据角色装载的路由
export const constantRouterMap = [
  {
    path: '/login',
    name: '',
    component: login
  },
  {
    path: '/',
    name: '',
    component: home,
    meta: {iconCls: 'fa fa-home fa-fw fz'}, 
    leaf: true,
    children: [
      // { path: '/', component: index, name: '首页' }
      { path: '/', component: index, name: Locales[s]['menu']['home'], pm: "首页" }
    ]
  },
  {
    path: '*',
    component: notFound
  }
]

// {
//   path: '/',
//     name: Locales[s]['menu']['terManage'],
//   pm: "设备管理",
//   component: home,
//   iconCls: 'fa fa-desktop fa-fw',
//   children: [
//   { path: '/terList', component: totalpages, name: Locales[s]['menu']['terManageSub']['myTer'], pm: '我的设备',
//     children:[
//       {path: '', component: terList},
//       {path: 'add',component: terAdd,name:Locales[s]['menu']['terManageSub']['addTer'], pm: '添加终端'},
//       {path: ':id/details',component: terDetails,name:Locales[s]['menu']['terManageSub']['detailTer'],pm: '终端详情'},
//       {path: ':id/terRisk',component: terRisk,name:Locales[s]['menu']['terManageSub']['riskInfo'],pm: '风控信息'},
//       {path: ':id/terAppLog/:no',component: terAppLog,name:Locales[s]['menu']['terManageSub']['runLog'],pm: '运行日志'},
//       {path: ':id/terAppList',component: terAppList,name:Locales[s]['menu']['terManageSub']['appList'],pm: '应用列表'},
//       {path: ':id/terAppBind/:no',component: terAppBind,name:Locales[s]['menu']['terManageSub']['appInstall'],pm: '应用安装'}
//     ]
//   },
//   { path: '/terBackups', component: terBackups, name: Locales[s]['menu']['terManageSub']['breakup'],pm: '终端备份'},
//   { path: '/terOta', component: totalpages, name: Locales[s]['menu']['terManageSub']['lockOTA'],pm: 'OTA锁定',children:[
//       {path:'',component:terOtaList},
//       {path:'lock',component:terOta,name: Locales[s]['menu']['terManageSub']['otaLock'],pm:'OTA锁定'}
//     ]},
//   { path: '/map', component: terMap, name: Locales[s]['menu']['terManageSub']['map'],pm: '终端地图'},
//   { path: '/log', component: terAppLog, name: Locales[s]['menu']['terManageSub']['log'],pm: '日志管理'}
// ]
// }

export default new Router({
  routes: constantRouterMap
})





// WEBPACK FOOTER //
// ./src/router/index.js